import ruStarsWithdrawTranslations from './i18n/ru.json'
import enStarsWithdrawTranslations from './i18n/en.json'
import ukStarsWithdrawTranslations from './i18n/uk.json'
import ptStarsWithdrawTranslations from './i18n/pt.json'
import esStarsWithdrawTranslations from './i18n/es.json'
import trStarsWithdrawTranslations from './i18n/tr.json'
import kkStarsWithdrawTranslations from './i18n/kk.json'
import uzStarsWithdrawTranslations from './i18n/uz.json'
import idStarsWithdrawTranslations from './i18n/id.json'
import tgStarsWithdrawTranslations from './i18n/tg.json'
import kyStarsWithdrawTranslations from './i18n/ky.json'
import arStarsWithdrawTranslations from './i18n/ar.json'
import faStarsWithdrawTranslations from './i18n/fa.json'

// Тексты вывода в Telegram Stars и в рублях (корневые ключи starsWithdraw и rubWithdraw)
export const withdrawResources = {
  ru: ruStarsWithdrawTranslations,
  en: enStarsWithdrawTranslations,
  uk: ukStarsWithdrawTranslations,
  pt: ptStarsWithdrawTranslations,
  es: esStarsWithdrawTranslations,
  tr: trStarsWithdrawTranslations,
  kk: kkStarsWithdrawTranslations,
  uz: uzStarsWithdrawTranslations,
  id: idStarsWithdrawTranslations,
  tg: tgStarsWithdrawTranslations,
  ky: kyStarsWithdrawTranslations,
  ar: arStarsWithdrawTranslations,
  fa: faStarsWithdrawTranslations
}
